<template>
    <div>
        <v-checkbox color="primary-dark" hide-details :label="course.nom" v-model="course.selected"
            @change="$emit('onToggle')" :disabled="!is_selectionnable || lock_select_parcours"
            :class="[!is_selectionnable ? 'line-through' : '']">
        </v-checkbox>
        <RadioSelectionVague v-if="display_vagues_selection" :item="course"></RadioSelectionVague>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import RadioSelectionVague from "./RadioSelectionVague.vue";

export default {
    props: ["item", "lock_select_parcours"],
    components: { RadioSelectionVague },
    name: 'CheckboxSelectionParcours',
    data() {
        return {
            // Your component data goes here
        };
    },
    computed: {
        ...mapStores(useMainStore),
        course() {
            return this.item;
        },
        is_selectionnable() {
            const course_selectionable = this.course.is_selectionnable(
                this.mainStore.module.status,
                this.mainStore.view_as_admin,
                this.mainStore.inscription_as_admin,
                this.mainStore.inscription_vip,
                this.mainStore.module.courses,
                this.mainStore.module.is_complet,

                this.mainStore.bookingSystem?.groupe
            );
            return course_selectionable;
        },
        display_vagues_selection() {
            const is_hidden_from_user = this.course.hide_vagues_from_user();
            const is_logged_admin = this.mainStore.authAdmin.isLogged;
            if (is_hidden_from_user && !is_logged_admin) {
                return false;
            }
            return this.course.vagues.list.length > 0 && this.course.selected;
        }
    },
    methods: {

        // Your component methods go here
    },

};
</script>

<style scoped>
/* Your component styles go here */
</style>